/**
 * 事件总线：事件管理
 */
 export default class BusEvent{

    /**
     * 场景资源发生变动
     */
    static SceneChange = 'scene-change'

    /**
     * 地图加载完成
     */
    static MapLoaded = 'map-loaded'

    /**
     * 快捷栏功能按钮
     */
    static ToolChange = 'tool-change'

    /**
     * 菜单栏禁用
     */
    static ToolDisabledChange = 'tool-disabled-change'

    /**
     * 登陆成功
     */
    static LoginSuccess = 'login-success'

    /**
     * 切换选择模型
     */
    static SelectedChange = 'selected-change'

    /**
     * 视角变化
     */
    static CameraChange = 'camera-change'

    /**
     * 右侧菜单禁用
     */
    static MenuDisbaledChange = 'menu-disabled-change'
}